import { UNSAFE_useMediaQuery as useMediaQuery } from '@atlaskit/primitives/responsive';
import { useState } from 'react';

/*
 * useIsMobile
 *
 * This hook is used to determine if the current viewport is mobile or not.
 */
export const useIsMobile = () => {
  var _mq$matches;
  const mq = useMediaQuery('below.sm', event => setIsMobile(event.matches));
  const [isMobile, setIsMobile] = useState((_mq$matches = mq === null || mq === void 0 ? void 0 : mq.matches) !== null && _mq$matches !== void 0 ? _mq$matches : false);
  return isMobile;
};